
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, delay, first, map, Observable, skip, Subject, switchMap, takeUntil, takeWhile, tap } from 'rxjs';
import { LgvAPIService, LgvClientService, LgvConstants, LgvUserService, NotificationService } from '../../core/core.module';
import { ObjectValidator } from '../../core/utility/lgv-form-validator';
import { RegexConstants, RegexValidator } from '../../core/utility/lgv-regex-validator';
import { LgvModel } from '../../data-models/longevity.model';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { environment as env } from '../../../environments/environment';

@Component({
    selector: 'lgv-edit-ppe-origination-id',
    templateUrl: './edit-ppe-origination-id.component.html',
    styleUrls: ['./edit-ppe-origination-id.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditPpeOriginationIDComponent implements OnInit {


    @Output() OnOKClicked: EventEmitter<string> = new EventEmitter();

    isLoading$ = new BehaviorSubject(false);
    originatorForm: UntypedFormGroup;
    onDestroy$ = new Subject();


    agentInfoParam: LgvModel.Agent = null;
    lpApplicationUserParam: LgvModel.ApplicationUser = null;
    pricingApplicationCompanyParam: LgvModel.ApplicationCompany = null;



    constructor(
        private http: HttpClient,
        private fb: UntypedFormBuilder,
        public notificationSvc: NotificationService,
        public lgvUserSvc: LgvUserService,
        public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
        public MatDialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any) {

        if (!!(data?.agentInfo)) {
            this.agentInfoParam = data.agentInfo;
        }
        if (!!(data?.pricingApplicationCompany)) {
            this.pricingApplicationCompanyParam = data.pricingApplicationCompany;
        }
        if (!!(data?.lpApplicationUser)) {
            this.lpApplicationUserParam = data.lpApplicationUser;
        }

    }

    ngOnInit(): void {
        this.lgvUserSvc.LoadUserRoles();
        this.initializeForm();
    }

    ngOnDestroy(): void {
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
    }

    initializeForm() {
        this.originatorForm = this.fb.group({
            originatorIndex: [this.lpApplicationUserParam?.indexValue, [Validators.required]]
        });
    }

    onCancel(): void {
        this.dialogRef.close({ action: false });
    }

    onSave() {
        if (this.originatorForm.invalid || !this.pricingApplicationCompanyParam ) { return; }

        let isNew = !(!!this.lpApplicationUserParam);

        let model = {
            userId: this.agentInfoParam.id,
            indexName: 'PPEOriginationId',
            indexValue: this.originatorForm.get('originatorIndex').value
        }

        let bldUrl = env.LgvApiBaseUrl;
        bldUrl += `/applications/${this.pricingApplicationCompanyParam.applicationId}/users/${this.agentInfoParam.id}`;

        let observableResponse = null;

        if (isNew) {
            observableResponse = this.http.post<any>(bldUrl, model).pipe(takeUntil(this.onDestroy$));
        }
        else {
            model['id'] =  this.lpApplicationUserParam?.id,
            model['applicationId'] = this.lpApplicationUserParam?.applicationId,
            observableResponse = this.http.patch<any>(bldUrl, model).pipe(takeUntil(this.onDestroy$));
        }

        observableResponse.subscribe(x => {
            this.notificationSvc.success('Origination Index has been updated');
            this.dialogRef.close({ action: true });
        },
            err => {
                console.log(err);
                this.notificationSvc.error("There was an error saving the Origination Index");
            });

    }
}
